/* eslint-disable no-unused-vars */
// ProfileContext.js
import React, { createContext, useState, useContext, useCallback } from "react";
import { createMPSBusinessProfile } from "../firebaseFunctions/createMPSBusinessProfile/createMPSBusinessProfile";
import { displayMPSProfile } from "../firebaseFunctions/displayMPSProfile/displayMPSProfile";
// import { saveUserProfile } from "./firebase"; // Import the Firebase function

// Create context
const MPSBusinessProfileContext = createContext();

// Create the provider
export const MPSBusinessProfileProvider = ({ children }) => {
  const [MPSBusinessProfileData, setMPSBusinessProfileData] = useState({
    userId: "",
    userType: "",
    fullName: "",
    businessEmail: "",
    businessName: "",
    companyLogoURL: "",
    businessType: "",
    businessPhoneNumber: "",
    isSMSPhoneNumberEqualToBusinessPhoneNumber: false,
    // smsPhoneNumber: "",
    businessDescription: "",
    businessCity: "",
    businessWebsite: "",
    businessSocialProfiles: {
      businessFacebook: "",
      businessInstagram: "",
      businessTikTok: "",
    },
    signedTermsOfService: true,
  });

  // Function to update profile data
  const updateMPSBusinessProfile = (newData) => {
    setMPSBusinessProfileData((prevData) => ({ ...prevData, ...newData }));
  };

  // Handle changes to the business website input
  const handleBusinessWebsiteChange = (inputValue) => {
    let modifiedWebsite = inputValue;

    // Automatically prepend "https://" if the input doesn't already have it
    if (
      inputValue &&
      !inputValue.startsWith("http://") &&
      !inputValue.startsWith("https://")
    ) {
      modifiedWebsite = "https://" + inputValue;
    }

    return modifiedWebsite;
  };

  // Function to submit profile data to Firebase
  const submitMPSBusinessProfile = async () => {
    const modifiedWebsiteURL = handleBusinessWebsiteChange(
      MPSBusinessProfileData.businessWebsite
    );
    try {
      // const response = await saveUserProfile(profileData);
      // console.log("Profile saved successfully", response.data);
      const socialProfilesList = Object.values(
        MPSBusinessProfileData.businessSocialProfiles
      );
      const request = {
        userId: MPSBusinessProfileData.userId,
        companyLogo: MPSBusinessProfileData.companyLogoURL,
        businessName: MPSBusinessProfileData.businessName,
        fullName: MPSBusinessProfileData.fullName,
        email: MPSBusinessProfileData.businessEmail,
        phoneNumber: MPSBusinessProfileData.businessPhoneNumber,
        smsPhoneNumber: MPSBusinessProfileData.useNumberForSMS ? MPSBusinessProfileData.businessPhoneNumber : null,
        description: MPSBusinessProfileData.businessDescription,
        socialMediaLinks: MPSBusinessProfileData.businessSocialProfiles, // Ensure it's an array

        website: modifiedWebsiteURL,
        typeOfBusiness: MPSBusinessProfileData.businessType,
        documents: MPSBusinessProfileData.documents || [], // Ensure it's an array of objects
        signedTermsOfService: MPSBusinessProfileData.signedTermsOfService,
      };

      const response = await createMPSBusinessProfile(request);
      console.log("Profile saved successfully", MPSBusinessProfileData);
      return true;
      // Handle success or notify user
    } catch (error) {
      console.error("Error saving profile:", error);
      return false;
      // Handle error or notify user
    }
  };
  const getMPSBusinessProfile = useCallback(
    async (MPSProfileID) => {
      try {
        console.log("ID", MPSProfileID);
        const response = await displayMPSProfile(MPSProfileID);
        // const response = {};
        if (
          response &&
          JSON.stringify(response) !== JSON.stringify(MPSBusinessProfileData)
        ) {
          updateMPSBusinessProfile(response); // Update only if data has changed
          console.log("MPSBusinessProfileData", MPSBusinessProfileData);
          return response;
        }
      } catch (error) {
        console.error("Error getting event data by ID: ", error);
      }
    },
    [MPSBusinessProfileData]
  ); // Memoize based on eventData

  return (
    <MPSBusinessProfileContext.Provider
      value={{
        MPSBusinessProfileData,
        updateMPSBusinessProfile,
        submitMPSBusinessProfile,
        getMPSBusinessProfile,
      }}
    >
      {children}
    </MPSBusinessProfileContext.Provider>
  );
};

// Custom hook to use the ProfileContext
export const useMPSBusinessProfile = () => {
  return useContext(MPSBusinessProfileContext);
};
